//#region src/dp-rules.ts
/**
* The one ruler namespace that the operator program owns in its DP Mimir tenant (`DP_ID`).
*
* The operator program makes the namespace contents equal the rule set: it writes every group of
* the set and deletes every group that the set does not name. It touches no other namespace.
*/
const DP_RULES_NAMESPACE = "zion-cp";
/** The most groups one rule set may hold. The DP Mimir ruler limit must be at or above it. */
const DP_RULES_MAX_GROUPS = 20;
/**
* The most rules one group may hold. It equals the CP value `rulerMaxRulesPerRuleGroup`, and the
* DP Mimir ruler limit must be at or above it.
*/
const DP_RULES_MAX_RULES_PER_GROUP = 100;
/**
* The most rules one set may hold over all its groups. It bounds `zion_dp_alert_active` at 200
* series per DP inside the `__cp__` series budget.
*/
const DP_RULES_MAX_RULES = 200;
/**
* The label names that no rule may set.
*
* - `zion_data_plane_id`: the operator program sets it from `DP_ID`. A rule that set it could
*   report an alert as another DP.
* - `alertname`: the ruler sets it from the rule's `alert`.
*/
const DP_RULE_RESERVED_LABELS = ["zion_data_plane_id", "alertname"];
//#endregion
export { DP_RULES_MAX_GROUPS, DP_RULES_MAX_RULES, DP_RULES_MAX_RULES_PER_GROUP, DP_RULES_NAMESPACE, DP_RULE_RESERVED_LABELS };

//# sourceMappingURL=dp-rules.js.map